module.exports = __webpack_public_path__ + "img/charging-kWh.12c2fe52.svg";